import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Lightweight Intersection Observer reveal for sections
const initRevealObserver = () => {
  const elements = document.querySelectorAll<HTMLElement>("[data-reveal]");
  if (!elements.length) return;
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        const el = entry.target as HTMLElement;
        if (entry.isIntersecting) {
          el.classList.add("in-view");
          obs.unobserve(el);
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -80px 0px" },
  );
  elements.forEach((el) => observer.observe(el));
};

if (document.readyState === "complete" || document.readyState === "interactive") {
  initRevealObserver();
} else {
  window.addEventListener("DOMContentLoaded", initRevealObserver, { once: true });
}
